// FieldPresetsStore.js

// I am not even sure this needs to be a Svelte store...

import { writable, get } from 'svelte/store';
// import { fetchGet, fetchPost } from '../api/fetcher,js';
import { fetchFieldPresetValues2} from '../api/services.ts';


// Select dropdown fields
import { AVAILABILITY, COVER_GRAN, LOC_PRECISION } from '../common/constants.js';

// Array fields
import { ADDITIONAL_INFO, NECESSARY_DOCS, NECESSARY_MATS } from '../common/constants.js';
import { INSURANCE_ACCEPT, ACCEPTS_INSURANCE, LANGUAGES } from '../common/constants.js';
import { COVER_AREAS, COVER_COUNTIES, COVER_POSTALS } from '../common/constants.js';

const ENDPOINTS = {
    [INSURANCE_ACCEPT]: 'accepted-insurances',          // in Swagger 9/22
    [ADDITIONAL_INFO]: 'additional-informations',       // in Swagger 9/22
    // [ADDITIONAL_REQS]: 'additional-requirements',    // in Swagger 9/22 but not used?

    [NECESSARY_DOCS]: 'necessary-documents',            // in Swagger 9/22
    [NECESSARY_MATS]: 'necessary-materials',            // in Swagger 9/22
    [LANGUAGES]: 'supported-languages',                 // in Swagger 9/22

    [COVER_AREAS]: 'coverageAreas',                     // NOT in Swagger 9/22
    [COVER_COUNTIES]: 'coverageCounties',               // NOT in Swagger 9/22
    [COVER_POSTALS]: 'coveragePostalCodes',             // NOT in Swagger 9/22
}

const RESP_PROP_NAMES = {
    [ADDITIONAL_INFO]: 'information',
    [NECESSARY_DOCS]: 'documentName',
    [NECESSARY_MATS]: 'materialName',
    [INSURANCE_ACCEPT]: 'insuranceName',
    [LANGUAGES]: 'supportedLanguage',

    [COVER_AREAS]: 'coverageAreas',
    [COVER_COUNTIES]: 'coverageCounties',
    [COVER_POSTALS]: 'coveragePostalCodes',
}


// these values are set from API calls
// should these have a blank as first option ???
export const fieldPresetsStore = writable({
    [AVAILABILITY]      : ['', 'available','unavailable','wait_list','others'],
    [COVER_GRAN]        : ['', 'city', 'county', 'state', 'others'],
    [LOC_PRECISION]     : ['', 'unknown', 'state_centroid', 'postal_centroid', 'street'],

    [ADDITIONAL_INFO]   : [],
    [NECESSARY_DOCS]    : ['license', 'passport'],
    [NECESSARY_MATS]    : [],
    [INSURANCE_ACCEPT]  : [],
    [ACCEPTS_INSURANCE] : ['unknown', 'yes', 'no'],
    [LANGUAGES]         : ['en'],

    [COVER_AREAS]       : ['', 'city', 'state', 'county', 'postal', 'others'],
    [COVER_COUNTIES]    : [],
    [COVER_POSTALS]     : [],
});

// call this to refresh the choices - gets all
// calls local fetchSingleFieldPresets() below
export const fetchAllFieldsPresets =  () => {
    let json = null;

    // look into using .all() for Promises
    fetchSingleFieldPresets(ADDITIONAL_INFO);
    fetchSingleFieldPresets(NECESSARY_DOCS);
    fetchSingleFieldPresets(NECESSARY_MATS);
    //fetchSingleFieldPresets(INSURANCE_ACCEPT);
    fetchSingleFieldPresets(LANGUAGES);

    // fetchSingleFieldPresets(COVER_AREAS);
    // fetchSingleFieldPresets(COVER_COUNTIES);
    // fetchSingleFieldPresets(COVER_POSTALS);
}


// calls fetchFieldPresetValues() in services.ts
export const fetchSingleFieldPresets = async (propName) => {
    let json = null;
    let values = [];

    let endpoint = ENDPOINTS[propName];
    if (endpoint === '') return;

    json = await fetchFieldPresetValues2(endpoint);
    
    if (!json) {
        console.error('fetchSingleFieldPresets ' + propName + ' did not return a json response');
        console.log(json);
        console.log('using preset values: ' + get(fieldPresetsStore)[propName]);
        return;
    }
    if (json.errors) {
        console.error('fetchSingleFieldPresets ' + propName + ' json.errors: ', json.errors);
        console.log(json);
        console.log('using preset values: ' + get(fieldPresetsStore)[propName]);
        return;
    }

    // console.log('fetchSingleFieldPresets ' + propName + ' returned valid json:');
    // console.log(json);

    // now we must parse into the arrays - ONLY THE VALUES WE NEED
    // must use correct response property name for each type
    values = json.map(obj => obj[RESP_PROP_NAMES[propName]]);
    get(fieldPresetsStore)[propName] = values;
}
